export enum ROUTE_ACCESS_DENIED {
  ERROR = 'error',
  // 앱 안 이전 기록이 있으면 뒤로, 없으면 역할 기본 경로로 갑니다
  BACK = 'back',
  ROLE_HOME = 'roleHome',
}

// 라우트 handle 의 접근 규칙이 검사하는 Unleash 플래그는 featureFlagConstant 에 있고, 접근식을 유지하려고 다시 내보냅니다
export { ROUTE_FEATURE_FLAG } from './featureFlagConstant';
